module.exports = __webpack_public_path__ + "img/1549540032.0ab2210e.jpg";